import * as React from "react";
import HeaderBackButton from "../components/HeaderBackButton";

import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Container,
  List,
  ListDivider,
  ListItem,
  ListItemContent,
  Snackbar,
  Stack,
  Typography,
} from "@mui/joy";
import { collection, doc, getDoc } from "firebase/firestore";
import CopyToClipboard from "react-copy-to-clipboard";
import { QRCode } from "react-qrcode-logo";
import { useLocation } from "react-router";
import styles from "../components/RecieveCard.module.css";
import { db } from "../config/firebase";

export default function ReceiveSingle() {
  let { state } = useLocation();

  const [adminWallet, setadminWallet] = React.useState("");
  const [loading, setLoading] = React.useState(true);
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const { address, network, image, code } = state;
  React.useEffect(() => {
    /*
    const docRef = doc(db, "walletaddresses", code);
    getDoc(docRef).then((data) => {
      console.log(data.data());

      if (data.data().address) {
        setadminWallet(data.data().address);
        setLoading(false);
      }
    });
    */
  }, []);
  return (
    <>
      <HeaderBackButton title={`Receive ${code}`} />
      <Container maxWidth="md">
        <Stack spacing={4}>
          <Box display={"flex"} justifyContent={"center"}>
            <QRCode
              size={200}
              value={address}
              logoImage={image}
              logoPaddingStyle="circle"
              removeQrCodeBehindLogo={true}
            />
          </Box>
          <List>
            <ListItem>
              <ListItemContent>
                <Stack direction={"column"} spacing={0}>
                  <Typography level="title-md"> {code} address</Typography>
                  <div className={styles.mkz6qaujb5nsymzcyzarctrecc2a3h}>
                    <Typography level="body-md" noWrap={true}>
                      {address}
                    </Typography>
                  </div>
                </Stack>
              </ListItemContent>

              <CopyToClipboard text={address} onCopy={() => setOpen(true)}>
                <Button
                  variant="solid"
                  color="primary"
                  sx={{ borderRadius: 10 }}
                >
                  Copy
                </Button>
              </CopyToClipboard>
            </ListItem>
            <ListDivider />
            <ListItem>
              <ListItemContent>Network</ListItemContent>
              {network}
            </ListItem>
            <ListDivider />
            <ListItem>
              <ListItemContent>Expected arrival</ListItemContent>
              <Chip color="neutral" variant="outlined">
                1
              </Chip>
            </ListItem>
            <ListDivider />
            <ListItem>
              <ListItemContent>Expected unlock</ListItemContent>
              <Chip color="neutral" variant="outlined">
                3
              </Chip>
            </ListItem>
          </List>
        </Stack>
      </Container>
      <Snackbar
        color="success"
        size="md"
        variant="soft"
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={open}
        onClose={handleClose}
      >
        Address copied
      </Snackbar>
    </>
  );
}
